export default "__VITE_ASSET__DGJVA3KQ__"